import React from 'react';
import { getReviewStatusDisplay } from '../../utils/formatReviewStatus';

/**
 * Single review row in the list. Click to select and load images.
 */
function ReviewListItem({ review, isSelected, onSelect }) {
  const statusDisplay = getReviewStatusDisplay(review.status);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onSelect(review.id, review.orderNumber)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(review.id, review.orderNumber);
        }
      }}
      className={`p-4 border rounded-lg cursor-pointer transition-colors ${
        isSelected
          ? 'border-green-500 bg-green-50 ring-2 ring-green-500 ring-offset-2'
          : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
      }`}
      aria-pressed={isSelected}
      aria-label={`Opinia ${review.id}, zamówienie ${review.orderNumber}`}
    >
      <div className="flex justify-between items-start gap-4">
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-gray-900">Opinia #{review.id}</p>
          <p className="text-sm text-gray-600">Zamówienie: {review.orderNumber}</p>
          <p className="text-sm text-gray-600 truncate" title={review.customerName || review.clientEmail}>
            Klient: {review.customerName || review.clientEmail}
          </p>
          <p className="text-xs text-gray-500 mt-1">Zdjęć: {review.imageCount ?? 0}</p>
        </div>
        <span
          className={`px-2 py-1 rounded text-xs font-medium shrink-0 ${statusDisplay.className}`}
        >
          {statusDisplay.label}
        </span>
      </div>
    </div>
  );
}

export default ReviewListItem;
